const {colors} = require('@apollo/space-kit')

exports.colors = {
  primary: '#2da5f7',
  //primary: '#56b8fb',
  codePrimary: colors.indigo.dark,
  // primary: colors.indigo.dark,
  secondary: colors.pink.base,
  tertiary: colors.teal.dark,
  divider: colors.silver.dark,
  background: colors.silver.light,
  background2: colors.silver.base,
  text1: colors.black.lighter,
  text2: colors.grey.dark,
  text3: colors.grey.light,
  text4: colors.silver.darker,
  warning: colors.yellow.base,
  shadow: colors.black.darker,
  highlight: colors.blue.base,
  highlight2: colors.blue.lighter,
  highlight3: colors.blue.lightest,
  hoverOpacity: 0.8
}
